import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface RadarChartProps {
  indicators: Array<{ name: string; max: number }>;
  series: Array<{ name: string; data: number[] }>;
  filled?: boolean;
  height?: number | string;
  loading?: boolean;
}

export function RadarChart({ indicators, series, filled, height, loading }: RadarChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'item' },
    legend: { bottom: 0 },
    radar: { indicator: indicators, radius: '60%' },
    series: series.map((s) => ({
      name: s.name,
      type: 'radar',
      data: [s.data],
      areaStyle: filled ? { opacity: 0.25 } : undefined,
      lineStyle: { width: 2 },
    })),
  };
  return <EChart option={option} height={height} loading={loading} />;
}
